import angularModule from 'Lessons/angularModule/scripts/lessons_module';
import 'ExtensionMethods/array';
import { Frame } from 'Lessons/Frame';

angularModule.factory('Lesson.FrameList.Frame', [
    'Iguana',
    'guid',
    'DeepExtend',
    '$q',
    (Iguana, guid, DeepExtend, $q) =>
        Iguana.subclass(function () {
            this.alias('Lesson.FrameList.Frame');
            this.setSciProperty('frame_type');
            this.embeddedIn('lesson');

            this.setCallback('after', 'copyAttrsOnInitialize', function () {
                this.annotations = this.annotations || {};
            });

            // overridden in componentized frame type
            Object.defineProperty(this.prototype, 'label', {
                get() {
                    return `Frame ${this.index() + 1}`;
                },
            });

            // overridden in componentized frame type
            Object.defineProperty(this.prototype, 'miniInstructions', {
                get() {
                    throw new Error('miniInstructions should be implemented in subclasses of Frame');
                },
                configurable: true,
            });

            Object.defineProperty(this.prototype, 'isPractice', {
                get() {
                    if (this.lesson() && this.lesson().isPractice) {
                        return true;
                    }

                    // when this frame is included in practice_frames, then it has
                    // to be marked as isPractice
                    return this.$$isPractice || false;
                },
                set(val) {
                    this.$$isPractice = val;
                },
            });

            Object.defineProperty(this.prototype, 'mainImage', {
                get() {
                    throw new Error('subclasses of Frame must implement mainImage');
                },
                set() {
                    throw new Error('subclasses of Frame must implement mainImage');
                },
                configurable: true, // specs
            });

            Object.defineProperty(this.prototype, 'authorComments', {
                get() {
                    return this.author_comments;
                },
                set(comments) {
                    this.author_comments = comments;
                },
                configurable: true, // specs
            });

            Object.defineProperty(this.prototype, 'newAuthorComment', {
                get() {
                    return this.$$author_comment;
                },
                set(comment) {
                    this.$$author_comment = comment;
                },
                configurable: true, // specs
            });

            Object.defineProperty(this.prototype, 'previousFrameIds', {
                get() {
                    return Frame.prototype.getPreviousFrameIds.apply(this);
                },
            });

            this.extend({
                // TODO: move this to iguana
                // this is here so that angular.forEach doesn't think all the frametype subclasses are
                // the same b/c angular uses toString for object equality
                toString() {
                    return this.alias();
                },

                // Return all of the subclasses that can actually be instantiated and saved into
                // the database, filtering out abstract classes
                subTypes() {
                    let klasses = [];
                    angular.forEach(this.subclasses, subclass => {
                        if (subclass.alias()) {
                            klasses.push(subclass);
                        }
                        klasses = klasses.concat(subclass.subTypes());
                    });
                    return klasses;
                },

                FrameViewModel: null, // subclasses should defined this

                title: null,
                thumbnail: null,
            });

            this.extendableObject('defaultAttrs');

            return {
                // subclass like 'no_interaction' for example must override this
                directiveName: null,
                reified: true,

                initialize($super, attrs) {
                    attrs = DeepExtend.extend(angular.copy(this.constructor.defaultAttrs()), attrs);
                    $super(attrs);

                    this.id = this.id || guid.generate();

                    // FIXME: define getters and setters on the protoype.  Not in the initialize.

                    // FIXME: move this into iguana. See how it's used in edit_frame_list.
                    // It allows us to set all of the attribues at once, which allows us to
                    // bind that to a json input.  BUG: If attributes are removed, however, they
                    // will still hang around.
                    Object.defineProperty(this, '$$attributes', {
                        get() {
                            return this.asJson();
                        },
                        set(_attrs) {
                            this.copyAttrs(_attrs);
                        },
                    });
                },

                reify: Frame.prototype.reify,
                prevFrame: Frame.prototype.prevFrame,
                nextFrame: Frame.prototype.nextFrame,
                index: Frame.prototype.index, // FIXME: move this into Iguana
                displayIndex: Frame.prototype.displayIndex, // 1-indexed for prettiness in editor
                createFrameViewModel: Frame.prototype.createFrameViewModel,
                logInfo: Frame.prototype.logInfo,
                containsText: Frame.prototype.containsText,
                replaceFrameReferences: Frame.prototype.replaceFrameReferences,
                copyMainTextAndImagesFrom: Frame.prototype.copyMainTextAndImagesFrom,
                formatAllText: Frame.prototype.formatAllText,
                deleteComment: Frame.prototype.deleteComment,
                addComment: Frame.prototype.addComment,
                toggleCommentCompleted: Frame.prototype.toggleCommentCompleted,

                imageForLabel(label) {
                    if (!this.images) {
                        return undefined;
                    }

                    for (const image of this.images) {
                        if (image.label === label) {
                            return image;
                        }
                    }

                    return undefined;
                },

                addImage() {
                    this.images = this.images || [];
                    const obj = {
                        id: guid.generate(),
                    };
                    this.images.push(obj);
                    return obj;
                },

                removeImage(image) {
                    Array.remove(this.images, image);
                },

                duplicate() {
                    const attrs = this.asJson();
                    // null out frame id, frame.js will populate it, if its not there
                    attrs.id = '';
                    return this.constructor.new(attrs);
                },

                getKeyTerms() {
                    throw new Error('Subclasses of Frame should define getKeyTerms');
                },

                useAlteredUrl(origUrl, alteredUrl) {
                    this.$$_alteredUrls = this.$$_alteredUrls || {};
                    this.$$_alteredUrls[origUrl] = alteredUrl;
                },

                getAlteredUrl(origUrl) {
                    this.$$_alteredUrls = this.$$_alteredUrls || {};
                    return this.$$_alteredUrls[origUrl] || origUrl;
                },

                expandExtraPanelsInitially() {
                    this.$$expandExtraPanelsInitially = true;
                },

                setLesson(lesson) {
                    this.$$embeddedIn = lesson;
                },

                preloadAssets() {
                    return this.preloadImages();
                },

                preloadImages() {
                    return $q.when();
                },

                recursivelyGetImageUrls() {
                    // overridden in componentized. Just need resolved promise to make pass
                    return $q.when();
                },
            };
        }),
]);
